"use client";
export function Chip({
  label,
  count,
  pressed,
  onClick,
}: {
  label: string;
  count?: number;
  pressed: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={pressed}
      className={`ph-filter-chip ${
        pressed ? "ph-filter-chip-pressed" : ""
      }`}
    >
      <span>{label}</span>
      {count !== undefined && (
        <span className="ph-filter-chip-count">{count}</span>
      )}
    </button>
  );
}
